import Joi from 'joi';
import type { SchemaOf, ExtractValues } from '../helpers';

export const loginDestinations = ['mobile'] as const;

export type LoginDestinations = ExtractValues<typeof loginDestinations>;

export interface ICheckLoginParams {
  email: string;
  destination: LoginDestinations;
}

const paramsSchemaMap: SchemaOf<ICheckLoginParams> = {
  email: Joi.string().required(),
  destination: Joi.string()
    .allow(...loginDestinations)
    .required(),
};

export const checkLoginParamsSchema = Joi.object(paramsSchemaMap);

export interface ICheckLoginResult {
  status: 'signed-up' | 'email-sent' | 'contact-administrator';
}
